import { render, staticRenderFns } from "./ServiceWorker.vue?vue&type=template&id=ac3cb57c"
import script from "./ServiceWorker.vue?vue&type=script&lang=js"
export * from "./ServiceWorker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports